export default __webpack_public_path__ + "static/media/modem-restart.79a7282d.png";